document.addEventListener('alpha.loaded', (e) => {
  document.body.classList.add('alpha-loaded')
})
